"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AWP_REVIEW_FINISHED = exports.AWP_REVIEW_STARTED = exports.AWP_MAILED_USCIS_APPLICATION_AT = exports.AWP_INTERVIEW_FINISHED = exports.AWP_INTERVIEW_STARTED = exports.RESTARTED = exports.UNARCHIVED = exports.ARCHIVED = exports.REVIEW_FINISHED = exports.REVIEW_STARTED = exports.INTERVIEW_SESSION_ENDED = exports.INTERVIEW_SESSION_PROGRESS = exports.INTERVIEW_SESSION_STARTED = exports.INTERVIEW_SESSION_INIT = exports.STUDENT_LOAN_MAILED = exports.STUDENT_LOAN_INTERVIEW_FINISHED = exports.STUDENT_LOAN_INTERVIEW_STARTED = exports.CREDITORS_MEETING_FINISHED = exports.CREDITORS_MEETING_PREP = exports.MAILED_TRUSTEE = exports.COURSE_TWO_FINISHED = exports.COURSE_TWO_STARTED = exports.FILED = exports.READY_FOR_REVIEW = exports.COURSE_ONE_FINISHED = exports.COURSE_ONE_STARTED = exports.INTERVIEW_FINISHED = exports.INTERVIEW_STARTED = exports.INTAKE = exports.CASE_DATA_TOUCH = void 0; // UNIVERSAL

exports.CASE_DATA_TOUCH = "caseDataTouch"; // BANKRUPTCY
// --- Milestones

exports.INTAKE = "intake";
exports.INTERVIEW_STARTED = "interviewStarted";
exports.INTERVIEW_FINISHED = "interviewFinished";
exports.COURSE_ONE_STARTED = "courseOneStarted";
exports.COURSE_ONE_FINISHED = "courseOneFinished";
exports.READY_FOR_REVIEW = "readyForReview";
exports.FILED = "filed";
exports.COURSE_TWO_STARTED = "courseTwoStarted";
exports.COURSE_TWO_FINISHED = "courseTwoFinished";
exports.MAILED_TRUSTEE = "mailedTrustee";
exports.CREDITORS_MEETING_PREP = "creditorsMeetingPrep";
exports.CREDITORS_MEETING_FINISHED = "creditorsMeetingFinished"; // --- Student Loans

exports.STUDENT_LOAN_INTERVIEW_STARTED = "studentLoanInterviewStarted";
exports.STUDENT_LOAN_INTERVIEW_FINISHED = "studentLoanInterviewFinished";
exports.STUDENT_LOAN_MAILED = "studentLoanMailed"; // --- Interviews

exports.INTERVIEW_SESSION_INIT = "interviewSessionInit";
exports.INTERVIEW_SESSION_STARTED = "interviewSessionStarted";
exports.INTERVIEW_SESSION_PROGRESS = "interviewSessionProgress";
exports.INTERVIEW_SESSION_ENDED = "interviewSessionEnded"; // --- Operational

exports.REVIEW_STARTED = "reviewStarted";
exports.REVIEW_FINISHED = "reviewFinished";
exports.ARCHIVED = "archived";
exports.UNARCHIVED = "unarchived";
exports.RESTARTED = "restarted"; // IMMIGRATION
// --- Milestones

exports.AWP_INTERVIEW_STARTED = "awpInterviewStarted";
exports.AWP_INTERVIEW_FINISHED = "awpInterviewFinished";
exports.AWP_MAILED_USCIS_APPLICATION_AT = "awpMailedUscisApplication"; // --- Operational

exports.AWP_REVIEW_STARTED = "awpReviewStarted";
exports.AWP_REVIEW_FINISHED = "awpReviewFinished";